<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="payroll.setup.payrollSetup" [menuService]="payrollModuleMenuService" [back]="true"> </app-header>
    <ui-card>
        <div
            *ngIf="padAgreementDocument && padAgreementDocument?.state !== 'new'; else displayDefaultPADBlockHeader"
            class="flex align-items-center justify-space-between"
        >
            <app-segment-header title="payroll.setup.preAuthorizedDebitAgreement"></app-segment-header>
            <ui-badge
                [type]="
                    padAgreementDocument.state === 'ready_for_review'
                        ? 'primary'
                        : padAgreementDocument.state === 'verified'
                          ? 'success'
                          : 'warning'
                "
                class="padding-left-1"
            >
                <span>{{ 'payroll.setup.selfOnboardingDocumentState.' + padAgreementDocument.state | translate }}</span>
            </ui-badge>
        </div>
        <ng-template #displayDefaultPADBlockHeader>
            <app-segment-header title="payroll.setup.preAuthorizedDebitAgreement"></app-segment-header>
        </ng-template>
        <div>
            <p>{{ 'payroll.setup.allowHumiToAutomaticallyDrawFundsFromTheBusinessBankAccount' | translate }}</p>
            <form
                *ngIf="
                    padAgreementDocument?.state === 'new' || padAgreementDocument?.state === 'rejected';
                    else displayUploadedPADView
                "
                class="ui static form"
                #form="ngForm"
                autocomplete="off"
            >
                <div
                    *ngIf="padAgreementDocument?.state === 'rejected' && padAgreementDocument?.rejectionReason"
                    class="padding-bottom-2 rejection-block"
                >
                    {{ 'payroll.setup.rejectionReason' | translate: { reason: padAgreementDocument?.rejectionReason } }}
                </div>
                <div class="app-grid flex align-items-center">
                    <div class="columns-3">
                        <a (click)="onDownloadTemplate('pad')"
                            ><strong>{{ 'payroll.setup.downloadPadAgreement' | translate }}</strong></a
                        >
                    </div>
                    <div class="columns-3 padding-left-1">
                        <ui-button
                            (click)="currentFileBeingUploaded = 'PadAgreement'; onUploadAuthorizationDocument()"
                            type="primary"
                            >{{ 'payroll.setup.uploadSignedDebitAgreement' | translate }}
                        </ui-button>
                    </div>
                </div>
            </form>
            <ng-template #displayUploadedPADView>
                <div class="flex justify-center">
                    <div class="uploaded-block">
                        <div
                            [innerHTML]="
                                'payroll.setup.uploadedBy'
                                    | translate
                                        : {
                                              firstName: padAgreementDocument?.documentUploaderFirstName,
                                              lastName: padAgreementDocument?.documentUploaderLastName,
                                              date: (padAgreementDocument?.createdAt | date: 'mediumDate'),
                                          }
                                    | sanitizeHtml
                            "
                        ></div>
                        <br />
                        <a (click)="onDownloadSignedAgreement(padAgreementDocument)"
                            ><strong>{{ 'payroll.setup.downloadSignedAgreement' | translate }}</strong></a
                        >
                    </div>
                </div>
            </ng-template>
        </div>
    </ui-card>
    <ui-card>
        <div
            *ngIf="
                roeAuthorizationDocument && roeAuthorizationDocument?.state !== 'new';
                else displayDefaultROEBlockHeader
            "
            class="flex align-items-center justify-space-between"
        >
            <app-segment-header title="payroll.setup.setUpHumiToSubmitRecordsOfEmployment"></app-segment-header>
            <ui-badge
                [type]="
                    roeAuthorizationDocument.state === 'ready_for_review'
                        ? 'primary'
                        : roeAuthorizationDocument.state === 'verified'
                          ? 'success'
                          : 'warning'
                "
                class="padding-left-1"
            >
                <span>{{
                    'payroll.setup.selfOnboardingDocumentState.' + roeAuthorizationDocument.state | translate
                }}</span>
            </ui-badge>
        </div>
        <ng-template #displayDefaultROEBlockHeader>
            <app-segment-header title="payroll.setup.setUpHumiToSubmitRecordsOfEmployment"></app-segment-header>
        </ng-template>
        <p>{{ 'payroll.setup.theRecordOfEmploymentRoeAllowsEmployeesToSignUpForEI' | translate }}</p>
        <p class="margin-top-3">
            {{ 'payroll.setup.inOrderToGrantHumiTheAuthorizationToSubmitRoEsOnYourBehalf' | translate }}
        </p>
        <div
            *ngIf="roeAuthorizationDocument?.state === 'rejected' && roeAuthorizationDocument?.rejectionReason"
            class="padding-bottom-2 rejection-block"
        >
            {{ 'payroll.setup.rejectionReason' | translate: { reason: roeAuthorizationDocument?.rejectionReason } }}
        </div>
        <form
            *ngIf="
                roeAuthorizationDocument?.state === 'new' || roeAuthorizationDocument?.state === 'rejected';
                else displayUploadedROEState
            "
            class="ui static form"
            autocomplete="off"
        >
            <div class="app-grid roe-submit-block">
                <div class="flex align-items-center justify-space-between padding-y-3 padding-x-3">
                    <div>
                        <mat-checkbox
                            [(ngModel)]="humiToSubmitROEs"
                            (ngModelChange)="saveRoeSubmissionState(true)"
                            #checkboxControl="ngModel"
                            name="humiSubmitROEs"
                            >{{ 'payroll.setup.iConfirm' | translate }}
                        </mat-checkbox>
                        <ul class="margin-top-1 margin-bottom-3 padding-left-2">
                            <li>
                                {{
                                    'payroll.setup.ihaveProcessedMyLastPayrollWithMyPreviousPayrollProvider' | translate
                                }}
                            </li>
                            <li>{{ 'payroll.setup.myPreviousPayrollProviderHasSubmittedRoEs' | translate }}</li>
                        </ul>
                        <div class="app-grid flex align-items-center">
                            <div class="columns-3">
                                <a
                                    *ngIf="
                                        roeAuthorizationDocument?.state === 'new' ||
                                        roeAuthorizationDocument?.state === 'rejected'
                                    "
                                    (click)="onDownloadTemplate('roe')"
                                    >{{ 'payroll.setup.downloadRoeConsentForm' | translate }}</a
                                >
                            </div>
                            <div class="columns-3 padding-left-1">
                                <ui-button
                                    type="primary"
                                    [disabled]="!humiToSubmitROEs"
                                    (click)="
                                        currentFileBeingUploaded = 'ROEAuthorization'; onUploadAuthorizationDocument()
                                    "
                                    >{{ 'payroll.setup.uploadSignedForm' | translate }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="app-grid padding-y-3 padding-x-3">
                <p class="form-subheader">{{ 'payroll.setup.dontWantToHaveHumiTakeItOffYourHands' | translate }}</p>
                <mat-checkbox
                    *ngIf="!!settings"
                    [(ngModel)]="settings.informPreviousPayrollProviderToSubmitRoe"
                    (ngModelChange)="saveRoeSubmissionState()"
                    #checkboxControl="ngModel"
                    name="userToSubmitROEs"
                    >{{ 'payroll.setup.iwillSubmitRoEsToServiceCanadaDirectly' | translate }}
                </mat-checkbox>
            </div>
        </form>
        <ng-template #displayUploadedROEState>
            <div class="app-grid roe-submit-block">
                <div class="flex align-items-center justify-center padding-y-3 padding-x-3">
                    <div>
                        <div class="uploaded-block">
                            <div
                                [innerHTML]="
                                    'payroll.setup.uploadedBy'
                                        | translate
                                            : {
                                                  firstName: roeAuthorizationDocument?.documentUploaderFirstName,
                                                  lastName: roeAuthorizationDocument?.documentUploaderLastName,
                                                  date: (roeAuthorizationDocument?.createdAt | date: 'mediumDate'),
                                              }
                                        | sanitizeHtml
                                "
                            ></div>
                            <br />
                            <a (click)="onDownloadSignedAgreement(roeAuthorizationDocument)"
                                ><strong>{{ 'payroll.setup.downloadSignedAgreement' | translate }}</strong></a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ui-card>
</div>
<app-self-onboarding-authorization-documents-upload
    style="display: none"
    #uploadAuthorizationDocumentsComponent
    (onFileUpload)="onUploadAuthorizationDocument($event)"
></app-self-onboarding-authorization-documents-upload>
